<template>
  <div>
    <!-- Button -->
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="regular"
      :disabled="disabled"
      @click="onClick"
    >
      {{ $t('pages.businessGuide.profitAndCashFlow.addDialog.fields.cashCycle.navigation') }}
    </ib-button>
    <!-- /Button -->
    <!-- Dialog Set Cash Cycle -->
    <dialog-set-cash-cycle
      :dialog-set-cash-cycle-visible="dialogVisible"
      @close-dialog-set-cash-cycle="onCloseDialog"
      @on-update-profit-and-cash-flow-view="getProfitAndCashFlow"
    />
    <!-- /Dialog Set Cash Cycle -->
  </div>
</template>

<script>
import DialogSetCashCycle from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/Dialogs/DialogSetCashCycle'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'SetCashCycle',

  components: {
    DialogSetCashCycle
  },

  mixins: [MixinApiCalculations, MixinIdeaRoles],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dialogVisible: false
    }
  },

  methods: {
    onClick () {
      if (!this.canEdit) return
      this.dialogVisible = true
    },

    onCloseDialog () {
      this.dialogVisible = false
    }
  }
}
</script>
